import { render } from "./MergeDialog.vue?vue&type=template&id=3ca9eb08&scoped=true"
import script from "./MergeDialog.vue?vue&type=script&lang=js"
export * from "./MergeDialog.vue?vue&type=script&lang=js"

import "./MergeDialog.vue?vue&type=style&index=0&id=3ca9eb08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca9eb08"]])

export default __exports__